import Card from "components/Card/Card";
import React, { useEffect, useState } from "react";
import {
  getAllBannerDetailsData,
  deleteDataRow,
  getBannerDetailsId,
} from "api/bannerNotice/bannerNotice";
import {
  Grid,
} from "react-bootstrap";
import NotificationSystem from "react-notification-system";
import BannerNoticeFilter from "./bannerNoticeFilter";
import BannerNoticeTable from "./bannerNoticeTable";
import LoadingSpinner from "views/Components/loadingSpinner";

import Swal from "sweetalert2";

const BannerList = (props) => {
  const _notificationSystem = React.createRef();
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const [getBannerNoticeData, setGetBannerNoticeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  useEffect(() => {
    fetchBannerNoticeData();
  }, [currentPage]);
  const handleDelete = (id) => {
    Swal.fire({
      width: "500px",
      title: "<font size='6px'>Are you sure?</font>",
      text: "You won't to Delete This Row ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "<font size='3px'>Yes, Delete it!</font>",
      cancelButtonText: "<font size='3px'>Cancel</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteRow(id);
      }
    });
  };
  const deleteRow = async (id) => {
    try {
      const res = await deleteDataRow(id, obj);
      console.log("Delete response:", res);

      if (res.status || res.success) {
        _notificationSystem.current.addNotification({
          message: "Banner Notice Deleted Successfully",
          level: "success",
        });

        await fetchBannerNoticeData();
      } else {
        _notificationSystem.current.addNotification({
          message: "Failed to delete Banner Notice.",
          level: "error",
        });
      }
    } catch (error) {
      console.error("Error deleting Banner Notice:", error);
      _notificationSystem.current.addNotification({
        message: "Error deleting Banner Notice",
        level: "error",
      });
    }
  };

  const fetchBannerNoticeData = async () => {
    let page = currentPage;
    setLoading(true);
    try {
      const response = await getAllBannerDetailsData(currentPage, obj);
      setGetBannerNoticeData(response.data || []);
      setTotalPage(response.meta.last_page);
      setCurrentPage(response.meta.current_page);
    } catch (error) {
      console.error("Error fetching Banner Notice:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleNavigateToAddBannerNotice = () => {
    props.history.push("/admin/add-banner-notice-list");
  };
  const handleNavigateToEditBannerNotice = (id) => {
    props.history.push(`/admin/edit-banner-notice-list/${id}`);
  };
  const safeParseJSON = (jsonString) => {
    try {
      if (!jsonString) return null;
      return JSON.parse(jsonString);
    } catch (error) {
      console.error("Invalid JSON in icon_path:", error);
      return null;
    }
  };

  return (
    <div className="main-content">
      <NotificationSystem ref={_notificationSystem} />
      <Grid fluid>
        <Card
          tableFullWidth
          content={
            <>
              <BannerNoticeFilter
                handleNavigateToAddBannerNotice={
                  handleNavigateToAddBannerNotice
                }
              />
              <BannerNoticeTable
                handleNavigateToEditBannerNotice={
                  handleNavigateToEditBannerNotice
                }
                totalPage={totalPage}
                setCurrentPage={setCurrentPage}
                handleDelete={handleDelete}
                getBannerData={getBannerNoticeData}
                loading={loading}
                LoadingSpinner={LoadingSpinner}
                safeParseJSON={safeParseJSON}
              />
            </>
          }
        ></Card>
      </Grid>
    </div>
  );
};
export default BannerList;
